/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, June 17th 2022, 7:16:09 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { AdvancedSettingsForm } from "service-builder/components/advanced-settings/AdvancedSettingsForm";

export const AdvancedSettingsPage = () => {
  return (
    <div className="os-service-builder-card">
      <AdvancedSettingsForm />
    </div>
  );
};
